import { MenuItem } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { PropsWithChildren, useState } from "react";

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
    label: string;
    testId?: string;
    disabled?: boolean;
    className?: string;
    placeholder?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChanged: (newValue: any) => void;
}

const useStyles = makeStyles(() => ({
    root: {
        marginBottom: "12px"
    }
}));

const SettingsSelect: React.FC<PropsWithChildren<Props>> = props => {
    const classes = useStyles();

    // TODO: Maybe it is easier to just pass the ID to use?
    const [id] = useState(`default-select-${Math.floor(Math.random() * 100_000).toFixed(5)}`);

    return (
        <FormControl
            size="small"
            variant="outlined"
            disabled={props.disabled}
            className={clsx(classes.root, props.className)}>

            {!props.placeholder && (
                <InputLabel id={id}>
                    {props.label}
                </InputLabel>
            )}

            <Select
                data-cy={props.testId}
                displayEmpty={!!props.placeholder}
                label={!props.placeholder ? props.label : undefined}
                labelId={!props.placeholder ? id : undefined}
                value={props.value || ""}
                onChange={e => props.onChanged(e.target.value)}>
                {props.placeholder && (
                    <MenuItem
                        value=""
                        disabled>
                        {props.label}
                    </MenuItem>
                )}
                {props.children}
            </Select>

        </FormControl>
    );
};

export default SettingsSelect;
